webpackJsonp([47587219260780],{

/***/ 418:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"excerpt":"Hello world.\n","frontmatter":{"title":"Hello World","path":"some-path","tags":["tag-1","tag-2","sample"]},"fields":{"slug":"/hello-world/"}}}]},"site":{"siteMetadata":{"title":"Chetan Arya's technology blog","facebook":{"appId":""}}}},"pathContext":{"tag":"tag-1"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-tag-1-68b5cb99c1c23c48a2c2.js